import { FieldRegistration } from '../fieldRegistry';
import {
  extractMediaValue,
  createMediaUpdateHandler,
  resolveMediaPlaceholder,
  createMediaSerializer,
  createMediaStoreSerializer,
  provideEmptyContext,
  validateMediaField
} from '../fieldUtils';
import { renderImageField } from './imageFieldRenderer';

export const imageFieldConfig: FieldRegistration = {
  renderer: renderImageField,
  extractor: extractMediaValue,
  updateHandler: createMediaUpdateHandler('CARD'),
  placeholderResolver: resolveMediaPlaceholder('images.vertical'),
  apiSerializer: createMediaSerializer('picture_ids'),
  storeSerializer: createMediaStoreSerializer(),
  contextProvider: provideEmptyContext,
  validator: validateMediaField
};
